import React, { useEffect, useState } from "react";
import "../SellerConfirmedOrders/SellerConfirmedOrders.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import emptycart from "../../assets/empty-cart.png";

export default function SellerNewOrders() {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BaseUrl}saller/new-orders`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setOrders(res?.data?.data ?? []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchOrders();
  }, [token]);

  return (
    <div className="orders-page mt-5 pt-5">
      <div className="container mt-5">
        <div className="row">

          {/* ===== Sidebar ===== */}

          {/* ===== Cards (نفس Confirmed بالظبط) ===== */}
          <div className="col-md-9 col-12 m-auto">
            <div className="cards-wrapper mt-4">

              {loading && <p className="text-center">Loading...</p>}

              {!loading && orders.length === 0 && (
                <div className="empty-orders text-center mb-5 pb-5">
                  <img  src={emptycart} alt="No orders" width="300" />
                  <h3 className="mt-3 fw-bold mb-5">لا توجد طلبات حالياً</h3>
                </div>
              )}

              {!loading &&
                orders.map((order) => (
                  <div
                    key={order.order_id}
                    className="modern-card"
                    onClick={() =>
                      navigate(`/seller/sellernewordersdetails/${order.order_id}`)
                    }
                  >
                    
                    {/* SIDE LOCK */}
                    <div className="side-lock">
                      <i className="fa fa-lock"></i>
                    </div>

                    {/* Header */}
                    <div className="card-header">
                      <span className="order-number">
                        {order.order_number}
                      </span>

                      <span className="status-badge">
                        {order.status?.toUpperCase()}
                      </span>
                    </div>

                    <hr />

                    {/* Details */}
                    <div className="card-details">
                      <div>
                        <span className="label">العدد</span>
                        <span className="value">
                          {order.count_items || 1}
                        </span>
                      </div>

                      <div>
                        <span className="label">التاريخ</span>
                        <span className="value">
                          {order.created_at?.slice(0, 10)}
                        </span>
                      </div>

                      <div>
                        <span className="label">الإجمالي</span>
                        <span className="total">
                          {order.final_total} ر.س
                        </span>
                      </div>
                    </div>

                  </div>
                ))}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}